
import React, { useState } from 'react';
import Modal from './ui/Modal';
import { authService } from '../services/authService';
import { toast } from 'react-toastify';

interface CategoryOption {
  id: string;
  name: string;
}

interface PostSignupModalProps {
  isOpen: boolean;
  categoryOptions: CategoryOption[];
  onSuccess?: () => void;
  showCloseButton?: boolean;
}

const PostSignupModal: React.FC<PostSignupModalProps> = ({
  isOpen,
  categoryOptions,
  onSuccess,
  showCloseButton = false,
}) => {
  const [orgName, setOrgName] = useState('');
  // const [modalDepartment, setModalDepartment] = useState<string>('');
  const [isSaving, setIsSaving] = useState(false);
  const isDisabled = !orgName.trim()


  const handleModalSubmit = async () => {
    if (!orgName?.trim()) {
      console.warn('Organization name required');
      return;
    }
    // if (!modalDepartment) {
    //   console.warn('Please select a department');
    //   return;
    // }

    const payload = {
      tenantName: orgName.trim(),
    };

    try {
      setIsSaving(true);
      const resp:any = await authService.addTenantDetails?.(payload);
      if (resp) {
        onSuccess?.();
        toast.success(resp?.message || "Department added successfully!")
      } else {
        console.warn('No matching save API method found on authService; update the call to your backend method name.');
      }
    } catch (err) {
      console.error('Failed to save organization details', err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => { /* Forced modal - no close by default. Caller can control showCloseButton */ }}
      title="Complete Organization Details"
      size="md"
      showCloseButton={showCloseButton}
      closeOnBackdropClick={false}
      closeOnEsc={false}
    >
      <div>
        <p className="text-sm text-gray-600 mb-4">Please provide your organization and select your department to finish setup.</p>

        <label className="flex flex-col text-sm mb-3">
          <span className="text-gray-600 text-xs font-medium">Organization  <span className='text-red-500'>*</span></span>
          <input
            value={orgName}
            onChange={e => setOrgName(e.target.value)}
            className="mt-1 p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-200"
            placeholder="Your organization name"
          />
        </label>


        <div className="flex justify-end gap-3">
        <button
          onClick={handleModalSubmit}
          disabled={isSaving || isDisabled}
          className={`
            px-4 py-2 rounded-lg text-white font-semibold
            ${isSaving || isDisabled
              ? 'bg-gray-300 cursor-not-allowed'
              : 'bg-agentic-primary-blue cursor-pointer'
            }
          `}
        >
          {isSaving ? 'Saving...' : 'Save & Continue'}
        </button>

        </div>
      </div>
    </Modal>
  );
};

export default PostSignupModal;


